/**
 * Light mode: keep primary (iwd-gold-* / accent) rest colors on hover and show a
 * focus-ring-style outline. Requires Tailwind `light` variant (parent [data-mode=light]).
 */
export const GOLD_PRIMARY_LIGHT_HOVER =
  'light:hover:border-iwd-gold-400/50 light:hover:bg-iwd-gold-400/10 light:hover:shadow-lg light:hover:shadow-iwd-gold-500/30'
